export default "__VITE_ASSET__CACqdWTR__"